import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import AuthCookies from './auth-cookies';
import MetaMaskService from '../services/wallet/meta-mask-service';

function MyAccountWidget(): React.ReactElement {
  const { getAddress, setAuthCookie } = AuthCookies();
  const metamaskService = new MetaMaskService();

  const handleDisconnect = () => {
    setAuthCookie('');
    window.location.href = '/login';
  };

  const handleNewAccounts = (newAccounts: string) => {
    if (!newAccounts || (newAccounts && newAccounts.length === 0)) handleDisconnect();
  };

  metamaskService.registerNewAccountHandler(handleNewAccounts);

  return (
    <div className="my-account">
      <DropdownButton align="end" id="dropdown-basic-button" title="My Account" variant="dark">
        <span title={getAddress()} className="bi bi-person-fill address d-block" style={{ padding: '.25rem 1rem', maxWidth: '200px' }}>{getAddress()}</span>
        <Dropdown.Item className="bi bi-box-arrow-right" onClick={handleDisconnect}>Disconnect</Dropdown.Item>
      </DropdownButton>
    </div>
  );
}

export default MyAccountWidget;
